export default __webpack_public_path__ + "static/media/photo--sm--misc-16.35a3f4fe.jpg";